export default __webpack_public_path__ + "static/mainpage-ecf97db3c83f8ff69a739d6c9ea24bb9.png";